export default __webpack_public_path__ + "static/media/two-user-white.48c05a4c.svg";